import _ from 'lodash'

const subscriptionPay = {
    restrict: 'E',
    bindings: {
        contractDraft: '<',
        sponsorValidation: '<',
        sponsorOkMessage: '<',
        promoValidation: '<',
        subscriptionType: '<',
        choosenMESTariff: '<choosenMesTariff',
        isUpdating: '<',
        onGoToPayment: '&',
        onContractDraftUpdate: '&',
    },
    template: require('./subscriptionPay.jade')(),
    /** @ngInject */ controller($element, DeviceChecker) {
        const ctrl = this
        ctrl.enablePayment = false
        ctrl.isMobile = DeviceChecker.isMobile
        ctrl.form = {
            hasConsent: null,
        }

        ctrl.isPromoValid = () => ctrl.promoValidation.isValid

        ctrl.updateConsent = (hasConsent) => {
            ctrl.onContractDraftUpdate({
                value: {
                    consent_curves: hasConsent,
                    consent_index: hasConsent,
                },
            })
        }

        ctrl.$onChanges = function (changes) {
            if (_.has(changes, 'contractDraft.currentValue.consent_curves')) {
                ctrl.form.hasConsent = changes.contractDraft.currentValue.consent_curves
            }
        }
    },
}

export default subscriptionPay



// WEBPACK FOOTER //
// ./src/states/subscription/component/subscriptionPay.js